import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const accountsService = {
    getAccounts,
    setActiveAccount,
};

function getAccounts() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/identity/accounts`, requestOptions).then(handleResponse);
}

function setActiveAccount(accountId) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/identity/active-account/${accountId}`, requestOptions).then(handleResponse);
}
